<div class="ss-box"
     [ngClass]="this.getSkewSentimentColorClass()"
     [class.skew-stale]="this.isStale"
     [class.skew-error]="!this.skewSentimentAvailable && !this.skewLoading"
     (click)="this.toggleOverlay(); $event.stopPropagation()">
  <dx-load-indicator width="10" height="10" [visible]="this.skewLoading"></dx-load-indicator>
  <span *ngIf="!this.skewLoading && this.skewSentimentAvailable">Sentiment: {{ this.skewSentiment }}</span>
  <ng-container *ngIf="!this.skewLoading && !this.skewSentimentAvailable">
    <span #naSpan
          class="na"
          (mouseenter)="this.showErrorTooltip($event)"
          (mouseleave)="this.hideErrorTooltip()">Sentiment: N/A</span>
    <dx-tooltip
      [target]="naSpan"
      [visible]="skewErrorTooltipVisible"
      position="top"
      *ngIf="this.skewErrorMessage">
      <div *dxTemplate="let data of 'content'" class="skew-error-tooltip">
        {{ this.skewErrorMessage }}
      </div>
    </dx-tooltip>
  </ng-container>
</div>

<div *ngIf="this.overlayVisible" class="overlay" [ngStyle]="this.overlayStyle" (click)="$event.stopPropagation()">
  <div class="skew-cheat-sheet-wrapper">

    <div class="skew-cheat-sheet">
      <div class="cheat-title">Sentiment</div>
      <div *ngFor="let range of skewSentimentRanges"
           class="cheat-row"
           [class.active]="this.isSkewRangeActive(range)"
           [class.row-red]="range.color === 'red'"
           [class.row-blue]="range.color === 'blue'"
           [class.row-neutral]="range.color === 'neutral'">
        <span class="range-label">{{ range.label }}</span>
        <span class="range-meaning">{{ range.meaning }}</span>
      </div>
    </div>

    <div *ngIf="this.isSuperUser"
         class="debug-trigger"
         (click)="this.toggleDebugPanel()">
      Debug
    </div>

    <div [style.display]="this.debugPanelVisible ? 'block' : 'none'" class="debug-panel">
      <dx-scroll-view height="100%">
        <div class="debug-title">
          Sentiment Debug
        </div>

        <dx-load-indicator [visible]="this.debugLoading" width="16" height="16"></dx-load-indicator>

        <ng-container *ngIf="this.debugData && !this.debugLoading">
          <div class="debug-summary">
            <div>Value: <strong>{{ this.debugData.value != null ? this.debugData.value : 'N/A' }}</strong> | Tier: {{ this.debugData.tier }} | Method: {{ this.debugData.method }}</div>
            <div>ATM: {{ this.debugData.atm }} | SPX: {{ this.debugData.spxPrice | number:'1.2-2' }} | Spread: ${{ this.debugData.spreadWidth }} | Target: ${{ this.debugData.targetPrice | number:'1.2-2' }}</div>
            <div>Majority: {{ this.debugData.majorityValue != null ? this.debugData.majorityValue : 'N/A' }} ({{ this.debugData.majorityCount }}/{{ this.debugData.totalProducing }}) | Avg: {{ this.debugData.averageOfProducing != null ? (this.debugData.averageOfProducing | number:'1.1-1') : 'N/A' }}</div>
            <div *ngIf="this.debugData.resolvedByAnchor" class="debug-anchor">
              Anchor: <strong>{{ this.formatExpDate(this.debugData.anchorExpiration) }}</strong>
              | Supporters: <span *ngIf="this.debugData.anchorSupporters?.length > 0">{{ this.formatOutlierDates(this.debugData.anchorSupporters) }}</span><span *ngIf="!this.debugData.anchorSupporters?.length">(none)</span>
            </div>
            <div *ngIf="this.debugData.pendingConfirmCount > 0" class="debug-candidate">
              Candidate: <strong>{{ this.debugData.pendingIsNA ? 'N/A' : this.debugData.pendingValue }}</strong>
              ({{ this.debugData.pendingConfirmCount }}/{{ this.debugData.confirmThreshold }} confirmations)
            </div>
            <div *ngIf="this.debugData.excludedOutliers?.length > 0">
              Outliers: <span class="outlier-text">{{ this.formatOutlierDates(this.debugData.excludedOutliers) }}</span>
            </div>
          </div>

          <div class="debug-expirations">
            <div class="exp-header">
              <span class="col-exp">Expiration</span>
              <span class="col-method">Method</span>
              <span class="col-value">Value</span>
              <span class="col-reason">Reason</span>
            </div>
            <div *ngFor="let exp of this.debugData.expirations"
                 class="exp-row"
                 [class.outlier]="this.isOutlier(exp)"
                 [class.chosen]="this.isChosenExpiration(exp)">
              <span class="col-exp">{{ this.formatExpDate(exp.expirationDate, exp.dte) }}</span>
              <span class="col-method">{{ exp.method === 'NA' ? 'N/A' : exp.method }}</span>
              <span class="col-value">{{ exp.value != null ? exp.value : '-' }}</span>
              <span class="col-reason">{{ exp.reason }}</span>
            </div>
          </div>
        </ng-container>

        <div *ngIf="!this.debugData && !this.debugLoading" class="debug-error">
          Failed to load debug data
        </div>
      </dx-scroll-view>
    </div>

  </div>
</div>
